var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.1189 62.7L46.3125 49.875M75.525 63.0562L67.6875 49.875M64.125 80.1562H49.875M64.125 80.1562C64.125 90.9776 72.8974 99.75 83.7188 99.75C94.5401 99.75 103.312 90.9776 103.312 80.1562C103.312 69.3349 94.5401 60.5625 83.7188 60.5625C72.8974 60.5625 64.125 69.3349 64.125 80.1562ZM49.875 80.1562C49.875 90.9776 41.1026 99.75 30.2812 99.75C19.4599 99.75 10.6875 90.9776 10.6875 80.1562C10.6875 69.3349 19.4599 60.5625 30.2812 60.5625C41.1026 60.5625 49.875 69.3349 49.875 80.1562ZM76.5938 33.8438C76.5938 44.6651 67.8213 53.4375 57 53.4375C46.1787 53.4375 37.4062 44.6651 37.4062 33.8438C37.4062 23.0224 46.1787 14.25 57 14.25C67.8213 14.25 76.5938 23.0224 76.5938 33.8438Z",
    stroke: "#FF7100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8438 67.6875L21.375 81.9375L28.5 83.7188L26.7188 92.625L39.1875 80.1562L32.0625 76.5938L33.8438 67.6875Z",
    stroke: "#FF7100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2812 67.6875L74.8125 81.9375L81.9375 83.7188L80.1562 92.625L92.625 80.1562L85.5 76.5938L87.2812 67.6875Z",
    stroke: "#FF7100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4938 21.375L47.025 35.625L54.15 37.4062L52.3688 46.3125L64.8375 33.8438L57.7125 30.2812L59.4938 21.375Z",
    stroke: "#FF7100"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/group-icon.2911faf75f403653b8859218e41001c2.svg";
export { ForwardRef as ReactComponent };